import { classNames } from "../../shared/utility";
import DatePickerInput from "../controls/DatePickerInput";

export default function DateRangeFilterDuos(props) {
  const {
    onChange,
    resetFilter,
    startDate,
    endDate,
    maxDate,
    hideTitle,
    showOneDate,
  } = props;

  return (
    <div className={hideTitle ? "" : "p-3"}>
      <div className={hideTitle ? "hidden" : "flex justify-between"}>
        <p className="text-sm text-gray-700 font-semibold">Date Range</p>
        <button
          onClick={() => resetFilter()}
          className="text-sm font-semibold main-purple"
        >
          Reset
        </button>
      </div>
      <div className="flex gap-3 mt-1">
        <DatePickerInput
          label="From:"
          name="startDate"
          onChange={(e) => onChange("startDate", e.target.value)}
          value={startDate}
          labelOn={true}
          maxDate={maxDate}
          type="text"
          dateFormat={"LLL dd, YYY"}
          labelDivClass="mb-0"
          labelClass="block text-sm font-medium text-gray-900"
        />
        <div className={classNames(showOneDate ? "hidden" : null)}>
          <DatePickerInput
            label="To:"
            name="endDate"
            onChange={(e) => onChange("endDate", e.target.value)}
            minDate={startDate}
            maxDate={maxDate}
            value={endDate}
            labelOn={true}
            type="text"
            dateFormat={"LLL dd, YYY"}
            labelDivClass="mb-0"
            labelClass="block text-sm font-medium text-gray-900"
          />
        </div>
      </div>
    </div>
  );
}
